import Introduction from '../../pages/introduction/NewspaperEducationDesktop'
import IntroductionMobile from '../../pages/introduction/NewspaperEducationMobile'
//import multiguard from 'vue-router-multiguard'

//import authGuard from '../../guards/auth.guard'

const introduction = {
  path: '/introduction',
  name: 'Introduction',
  component: window.innerWidth >= 1025 ? Introduction : IntroductionMobile,
  meta: {
    title: 'Page Title',
  },
  //Remove auth from introduction page
  //beforeEnter: multiguard([authGuard])

}

export default introduction
